import { AbstractService } from '@uniqoders/sdk';

export default class DashboardService extends AbstractService {
  /**
   * Retrieve CMS dashboard stats for an agency
   */
  public getCmsDashboardStats(agency: string, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/dashboard/stats', { agency }),
      params,
      headers,
    });
  }
}
